import styled from "styled-components";

import { getOpacityColor, grayScale } from "@enkor/design/colors";

export const EventCard = styled.div`
  display: flex;
  justify-content: space-between;

  height: 142px;
  padding: 8px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale[300], 0.7)};
`;

export const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContentSkeleton = styled.div`
  border-radius: 2px;

  background-color: ${getOpacityColor(grayScale.white, 0.05)};
`;

export const ImageSkeleton = styled(ContentSkeleton)`
  width: 96px;
  height: 96px;
  border-radius: 8px;
`;

export const LongContent = styled(ContentSkeleton)`
  width: 210px;
  height: 24px;
`;

export const ShortContent = styled(ContentSkeleton)`
  width: 128px;
  height: 24px;
`;
